import { parseResponse } from "../../utils/common_lib";
import { baseApi } from "../baseApi";
export const immunizationsApi = baseApi.injectEndpoints({
   tagTypes: ["Immunizations"],
   endpoints: (builder) => ({
      getImmunizations: builder.query({
         query: (params) => {
            return {
               url: `/immunizations.json`,
               method: "GET",
               params: params,
            };
         },
         transformResponse: (response, meta, arg) => {
            return parseResponse(response);
         },
      }),
   }),
});

// Export hooks for usage in functional components
export const { useGetImmunizationsQuery } = immunizationsApi;
